import type { VariantProps } from "class-variance-authority";
import { type ComponentProps } from "react";

import { cn } from "../../utils/cn.util";
import { indicatorStyles, itemStyles } from "./style";

export interface RadioGroupMarkProps extends Omit<ComponentProps<"span">, "color">, VariantProps<typeof itemStyles> {
  checked: boolean;
  disabled?: boolean;
}

/**
 * The radio's look without its behaviour, for a control that is a radio itself — a menu's radio row, whose group
 * keeps one value picked. Inside a `RadioGroup.Root`, use `RadioGroup.Item`.
 */
export const Mark = ({ ref, className, checked, disabled, size = "sm", color, ...props }: RadioGroupMarkProps) => {
  const state = checked ? "checked" : "unchecked";
  const disabledAttribute = disabled ? "" : undefined;

  return (
    <span
      ref={ref}
      aria-hidden
      data-state={state}
      data-disabled={disabledAttribute}
      className={cn(itemStyles({ size, color }), "inline-flex shrink-0", className)}
      {...props}
    >
      <span data-state={state} data-disabled={disabledAttribute} className={indicatorStyles({ size, color })} />
    </span>
  );
};

Mark.displayName = "RadioGroupMark";
